import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import {
  BtnGroupStyle,
  CardTitle,
  DataGridListStyle,
  HtmlTooltip,
} from "../../../Theme";
import TrashIcon from "../../../images/icons/TrashIcon.svg";
import { YSButton } from "../../../uikit/YSButton";
import InfoIcon from "../../../images/icons/InfoIcon.svg";
import {
  BriefCaseCancelrxDetails,
  BriefCaseList,
  RemoveBriefCaseCancelrxById,
} from "../../../Apis/AuthApiServices";
import { v4 as uuid } from "uuid";
import NoRecords from "../../../components/NoRecords";
import YSSnackBar from "../../../uikit/YSSnackBar";
import { DialogPopup } from "../../../components/DialogPopup";
import ConfirmPopup from "../../../components/ConfirmPopup";
import useFetch from "../../../CustomHooks/useFetch";
import ErrorOverlay from "../../../components/ErrorOverlay";
import { authenticatedDigitalRxDownloadUrl } from "../../../Apis/Https";
import Download from "@mui/icons-material/Download";

const CancelRxDetails = (props: any) => {
  const { cancelRxDetails } = props;
  return (
    <>
      <Typography component={"div"} variant={"h6"} fontWeight={700}>
        CancelRx Information
      </Typography>
      <Grid container rowSpacing={1} columnSpacing={2}>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Date :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.writtenDate
              ? "Not Available"
              : cancelRxDetails[0]?.writtenDate}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Patient Name :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.patientName
              ? "Not Available"
              : cancelRxDetails[0]?.patientName}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Patient Id :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.patientId
              ? "Not Available"
              : cancelRxDetails[0]?.patientId}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Date of Birth:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.patientDateOfBirth
              ? "Not Available"
              : cancelRxDetails[0]?.patientDateOfBirth}{" "}
            + <strong>Age:</strong> (
            {cancelRxDetails[0]?.age ?? "Not Available"})
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Gender :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.patientGender
              ? "Not Available"
              : cancelRxDetails[0]?.patientGender}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Address :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.patientAddress
              ? "Not Available"
              : cancelRxDetails[0]?.patientAddress}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Phone Number :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.phoneNumber
              ? "Not Available"
              : cancelRxDetails[0]?.phoneNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Height:
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.height
              ? "Not Available"
              : cancelRxDetails[0]?.height}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Weight :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.weight
              ? "Not Available"
              : cancelRxDetails[0]?.weight}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Drug Description :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.drugDescription
              ? "Not Available"
              : cancelRxDetails[0]?.drugDescription}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            SIG :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.sig
              ? "Not Available"
              : cancelRxDetails[0]?.sig}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Days Supply :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.daysSupply
              ? "Not Available"
              : cancelRxDetails[0]?.daysSupply}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Quantity :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.quantity
              ? "Not Available"
              : cancelRxDetails[0]?.quantity}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Refill :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.refills
              ? "Not Available"
              : cancelRxDetails[0]?.refills}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Reason :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.reason
              ? "Not Available"
              : cancelRxDetails[0]?.reason}
          </Typography>
        </Grid>
        <Grid item xs={12} md={4}>
          <Typography component={"div"} variant={"body2"} fontWeight={600}>
            Status :
          </Typography>
        </Grid>
        <Grid item xs={12} md={8}>
          <Typography component={"div"} variant={"body2"}>
            {!cancelRxDetails[0]?.status
              ? "Not Available"
              : cancelRxDetails[0]?.status}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

function ToolTip(props: any) {
  const { row } = props;
  let Params = {
    uri: row?.uri,
    briefcaseId: row?.briefcaseId,
  };
  const { data: cancelRxDetails } = useFetch(
    Params,
    BriefCaseCancelrxDetails,
    []
  );
  return (
    <Typography className="textwrap">
      <Typography component="div" variant="body2">
        {row.documentName ?? "N/A"}{" "}
      </Typography>
      <HtmlTooltip
        placement="right"
        arrow
        title={<CancelRxDetails cancelRxDetails={cancelRxDetails} />}
      >
        <IconButton className="tooltip">
          <img src={InfoIcon} alt="Tooltip" loading="lazy" />
        </IconButton>
      </HtmlTooltip>
    </Typography>
  );
}
export default function MyBreifCaseDetails(props: any) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [pagination, setPagination] = useState<any>({});
  const [selectionData, setSelectionData] = useState("");
  const [deletePopup, setDeletePopup] = useState(false);
  const [rowCountState, setRowCountState] = useState<any>(
    pagination?.totalItems || 0
  );
  const [deleteStateData, setDeleteStateData] = useState<any>({
    message: "",
    open: false,
    variant: "",
  });
  const handleShowDeletePopupClick = () => {
    setDeletePopup(true);
  };
  const handleHideDeletePopupClick = () => {
    setDeletePopup(false);
  };

  const columnsMyBriefCaseReports: GridColDef[] = [
    {
      field: "documentName",
      headerName: "Name",
      width: 360,
      cellClassName: "w50",
      headerClassName: "w50",
    },

    {
      field: "createdDate",
      headerName: "Created Date",
      width: 120,
      cellClassName: "w12",
      headerClassName: "w12",
    },
    {
      field: "documentType",
      headerName: "File Type",
      width: 80,
      cellClassName: "w10",
      headerClassName: "w10",
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      cellClassName: "w10",
      headerClassName: "w10",
    },
    {
      field: "access",
      headerName: "Access Indicator",
      width: 120,
      cellClassName: "w18",
      headerClassName: "w18",
      renderCell: ({ row: accesing }) => {
        return (
          <>
            <Typography component="div" variant="body2">
              {accesing?.access ? "Accessed!" : "Not Accessed!"}
            </Typography>
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: ({ row }) => {
        return (
          <>
            {row?.access && (
              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    handleShowDeletePopupClick();
                    setSelectionData(row.briefcaseId);
                  }}
                >
                  <img src={TrashIcon} alt="Delete" loading="lazy" />
                </IconButton>
              </Tooltip>
            )}
            <Tooltip title="Download">
              <a
                href={authenticatedDigitalRxDownloadUrl(
                  `drx/api/briefcase/report/download.do?briefcaseId=${row?.briefcaseId}`
                )}
                download
              >
                <Download />
              </a>
            </Tooltip>
          </>
        );
      },
    },
  ];

  const columnsMyBriefCaseCancelRx: GridColDef[] = [
    {
      field: "documentName",
      headerName: "Description",
      width: 360,
      cellClassName: "w35",
      headerClassName: "w35",
      renderCell: ({ row }) => <ToolTip row={row} />,
    },

    {
      field: "patientName",
      headerName: "Patient Name",
      width: 120,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "createdDate",
      headerName: "Created Date",
      width: 120,
      cellClassName: "w15",
      headerClassName: "w15",
    },
    {
      field: "access",
      headerName: "Access Indicator",
      width: 120,
      cellClassName: "w15",
      headerClassName: "w15",
      renderCell: ({ row }) => {
        return (
          <>
            <Typography component="div" variant="body2">
              {row?.access ? "Accessed" : "Not Accessed"}
            </Typography>
          </>
        );
      },
    },
    {
      field: "action",
      headerName: "Action",
      width: 120,
      cellClassName: "w10",
      headerClassName: "w10",
      renderCell: ({ row }) => {
        return (
          row?.access && (
            <>
              <Tooltip title="Delete">
                <IconButton
                  onClick={() => {
                    handleShowDeletePopupClick();
                    setSelectionData(row.briefcaseId);
                  }}
                >
                  <img src={TrashIcon} alt="Delete" loading="lazy" />
                </IconButton>
              </Tooltip>
            </>
          )
        );
      },
    },
  ];

  const deleteRowData = async () => {
    try {
      const params = new URLSearchParams();
      params.append("breifcaseId", selectionData);
      const result = await RemoveBriefCaseCancelrxById(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.response[0]?.message,
            variant: "success",
            open: true,
          };
        });
        getBriefCaseList(page);
      } else {
        setDeleteStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
      }
    } catch (err: any) {
      setDeleteStateData((prevState: any) => {
        return {
          ...prevState,
          message: "Try Again After Some Time!",
          variant: "error",
          open: true,
        };
      });
    }
  };

  const getBriefCaseList = async (nextPage: any) => {
    try {
      setLoading(true);
      const doctorId: any = localStorage.getItem("doctorId");
      const params = new URLSearchParams({
        doctorId: doctorId,
        type: props?.Type,
        pageNumber: nextPage,
      });
      const result = await BriefCaseList(params);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response[0]?.items);
        setPagination(result?.data?.response[0]?.pagination);
        setLoading(false);
      } else {
        setData([]);
        setLoading(false);
      }
    } catch (err) {
      setError(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    getBriefCaseList(page);
  }, [page]);

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      pagination?.totalItems !== undefined
        ? pagination?.totalItems
        : prevRowCountState
    );
  }, [pagination?.totalItems, setRowCountState]);
  return (
    <>
      {props?.Type === "canrx" ? (
        <>
          {" "}
          <Grid item xs={12}>
            <CardTitle className="primary">
              <Typography component="div" variant="body2">
                Cancel Rx
              </Typography>
            </CardTitle>
          </Grid>
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={data}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columnsMyBriefCaseCancelRx}
                autoHeight
                rowHeight={40}
                loading={loading}
                getRowId={(row) => row.briefcaseId ?? uuid()}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                paginationMode="server"
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                rowCount={rowCountState}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
              />
            </DataGridListStyle>
          </Grid>
        </>
      ) : (
        <>
          {" "}
          <Grid item xs={12}>
            <CardTitle className="primary">
              <Typography component="div" variant="body2">
                Reports
              </Typography>
            </CardTitle>
          </Grid>
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={data}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columnsMyBriefCaseReports}
                autoHeight
                rowHeight={40}
                getRowId={(row) => row.briefcaseId ?? uuid()}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                paginationMode="server"
                loading={loading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={error || undefined}
                rowCount={rowCountState}
                page={page}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
              />
            </DataGridListStyle>
          </Grid>
        </>
      )}

      <Grid item xs={12}>
        <BtnGroupStyle className="middle">
          <YSButton
            className=""
            children={"Back"}
            variant={"outlined"}
            size={"large"}
            onClick={() => {
              props.setShowFlow(false);
            }}
          />{" "}
        </BtnGroupStyle>
      </Grid>
      <DialogPopup
        windowsize={"sm"}
        show={deletePopup}
        handleShowPopupClick={handleShowDeletePopupClick}
        handleHidePopupClick={handleHideDeletePopupClick}
        close={true}
      >
        <ConfirmPopup
          deleteRowData={deleteRowData}
          handleHideDeletePopupClick={handleHideDeletePopupClick}
        />
      </DialogPopup>
      <YSSnackBar
        message={deleteStateData.message}
        variant={deleteStateData.variant}
        open={deleteStateData.open}
        handleClose={() => {
          setDeleteStateData((prevState: any) => {
            return { ...prevState, open: false };
          });
        }}
      />
    </>
  );
}
